// extracted by mini-css-extract-plugin
export default {"card_product":"CardProduct_card_product__R5sOE","favorite_button":"CardProduct_favorite_button__VY01d","card_product_body":"CardProduct_card_product_body__pqjGJ"};